import { render, staticRenderFns } from "./ItemProduct.vue?vue&type=template&id=57d52ed6&scoped=true&"
import script from "./ItemProduct.vue?vue&type=script&lang=js&"
export * from "./ItemProduct.vue?vue&type=script&lang=js&"
import style0 from "./ItemProduct.vue?vue&type=style&index=0&id=57d52ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d52ed6",
  null
  
)

export default component.exports